import React from 'react';
import { tone } from './tones';

/**
 * Standard page header: optional icon chip, title, one-line description and right-aligned actions.
 * `children` renders below (e.g. tabs or a filter bar).
 */
export default function PageHeader({ icon, iconTone = 'brand', title, description, actions, meta, children, className = '' }) {
    return (
        <header className={`mb-6 ${className}`}>
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
                <div className="flex items-start gap-3 min-w-0">
                    {icon && (
                        <span className={`mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-lg ${tone(iconTone).chip}`}>
                            {icon}
                        </span>
                    )}
                    <div className="min-w-0">
                        <h1 className="m-0 text-[22px] sm:text-2xl font-semibold tracking-tight text-surface-900 leading-tight">{title}</h1>
                        {description && <p className="m-0 mt-1 text-sm text-surface-500 max-w-3xl">{description}</p>}
                        {meta && <div className="mt-2 flex flex-wrap items-center gap-2">{meta}</div>}
                    </div>
                </div>
                {actions && <div className="flex flex-wrap items-center gap-2 sm:justify-end shrink-0">{actions}</div>}
            </div>
            {children && <div className="mt-5">{children}</div>}
        </header>
    );
}
